<template>
  <MdApp>
    <MdAppToolbar class="md-primary" md-elevation="1">
      <h3 class="md-title">
        <RouterLink to="/">iGUIDE Virtual Showing</RouterLink>
      </h3>
    </MdAppToolbar>

    <MdAppContent class="md-layout md-alignment-center-center">
      <form novalidate @submit.prevent="login">

        <MdField :class="errorClass">
          <label>Full Name</label>
          <MdInput v-model="fullName" required max="50" />
          <span v-if="!valid" class="md-helper-text">Required</span>
          <span v-if="error" class="md-helper-text">{{ error }}</span>
        </MdField>

        <MdButton class="md-raised md-primary" type="submit">
          Continue
        </MdButton>
      </form >
    </MdAppContent>
  </MdApp>
</template>

<script>
import { auth } from '../firebase';
import { signInAnonymously, updateProfile } from 'firebase/auth';

export default {
  props: {
    nextUrl: { type: String, default: '' },
  },

  data() {
    return {
      fullName: '',
      showErrors: false,
      error: '',
    };
  },

  computed: {
    valid() {
      return this.fullName.length > 0;
    },

    errorClass() {
      return { 'md-invalid': this.showErrors && (this.error || !this.valid) };
    },
  },

  methods: {
    async login() {
      const { fullName, valid } = this;
      if (!fullName || !valid) {
        this.showErrors = !valid;
        return;
      }

      try {
        const { user } = await signInAnonymously(auth());
        await updateProfile(user, {
          displayName: this.fullName,
        });
        this.$root.$data.setUser(user);
        this.$router.replace(this.nextUrl || '/');
      } catch (err) {
        this.showErrors = true;
        this.error = `[${err.code}] ${err.message}`;
      }
    },
  },
};
</script>
